<template>
  <Tooltip side="bottom" :side-offset="8" :delay-duration="400">
    <Button type="button" size="sm" @click="isShareDialogOpen = true">
      <template #startIcon>
        <Share2 />
      </template>
      Share
    </Button>

    <template #content>
      <p>Share project</p>
    </template>
  </Tooltip>
  <ShareDialog v-model:open="isShareDialogOpen" />
</template>

<script setup>
import { ref } from 'vue';
import { Share2 } from 'lucide-vue-next';
import { Button } from '@ui/components/button';
import { Tooltip } from '@ui/components/tooltip';
import ShareDialog from '@/features/projectSharing/ShareDialog.vue';

const isShareDialogOpen = ref(false);
</script>
